<template>
    <div>
        <h1 class="view-title" data-v-step-vehicle="1">
			VEÍCULOS <span v-popover:tooltip.right="'Seção de gerenciamento dos Veículos'"><i class="fas fa-question-circle"></i></span>
		</h1>
        
        <div class="inner-content shadowed">
            <div class="inner-content-title">
				Lista <span v-popover:tooltip.right="'Lista dos veículos cadastrados'"><i class="fas fa-question-circle"></i></span>
				<button class="add_new_origin" @click="create()" data-v-step-vehicle="3">
					<i class="fa fa-plus"></i> ADICIONAR
				</button>
                <button class="btn btn-link btn-right" @click="$refs.tour.editTour()" style="margin-top: 10px; margin-left: 15px;" data-v-step-vehicle="2">
                    <i class="fas fa-question-circle"></i> TOUR
                </button>
			</div>
            
            <div class="row">
				<div class="col-xs-12 -col-lg-12">
                    <div class="search" data-v-step-vehicle="4">
                        <label>Filtro <span v-popover:tooltip.right="'Informe uma palavra-chave para identificação do registro desejado'"><i class="fas fa-question-circle"></i></span>:</label>
                        <input type="text" v-model="search" @keydown.enter.prevent="load(true)" /> 
                    </div>
                    <Table 
                    :loading="loading"
                    :headers="headers" 
                    :ordering="ordering"
                    :order="order"
                    @reorder="(o) => { order = o; load(); }"
                    :list="list" 
                    :page="page"
                    :per_page="per_page" 
                    :total="total" 
                    :modifiers="modifiers"
                    @next="() => { page++; load(); }" 
                    @prev="() => { page--; load(); }"
                    v-slot="{item}"
                    data-v-step-vehicle="5">
                        <button class="button-edit" @click="edit(item)" title="Editar veículo">
                            <i class="fa fa-fw fa-edit"></i>
                        </button>
                        <button class="button-remove" @click="remove(item.id)" title="Remover veículo">
                            <i class="fa fa-fw fa-trash"></i>
                        </button>
                    </Table>
                </div>
            </div>
        </div>

        <VehicleForm v-if="current" :current="current" :my_drivers="my_drivers" />

        <Tour
            tour="Vehicle"
            :steps="tour_steps"
			:callbackOnFinish="true"
			ref="tour"
        />
    </div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import Tour from "@/components/Tour";
import VehicleForm from './Vehicle/VehicleForm';

export default {
    name: "Vehicle",

    components: {
        Table,
        Tour,
        VehicleForm,
    },

    data: function() {
        return {
            loading: false,
            search: "",
			headers: {
                license_plate: "Placa",
                brand: "Marca",
                vehicle_type: "Tipo",
                bodywork: "Carroceria",
                model: "Modelo",
                weight_capacity: "Cap. Peso",
                volume_capacity: "Cap. Volume",
                fuel_type: "Combustível",
                expanded_center: "Centro Expandido (SP)",
                rotation_day: "Rodízio (SP)",
            },
            ordering: ['license_plate', 'brand', 'vehicle_type', 'bodywork', 'model', 'weight_capacity', 'fuel_type', 'expanded_center'],
            order: 'license_plate-ASC',
            list: [],
            page: 0,
            per_page: 20,
            total: 0,
            
            current: false,
            my_drivers: [],
            modifiers: {
				brand: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				vehicle_type: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				bodywork: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				model: function(d) {
                    let str = "";
					let color = "";

					if (d) { 
                        str = d.toLowerCase();
					} else {						
                        str = "Não Definido";
						color = "color: #aaa";
					}

					return `<span class="capitalized" title="${str}" style="${color}">${str}</span>`;
				},
				weight_capacity: function(d) {
					return '<span title="' + d + ' kg">' + d + ' kg</span>';
				},
				volume_capacity: function(d) {
                    let str = "";
					let color = "";

					if (d) { 
                        str = d + ' m³';
					} else {
                        str = "Não Definido";
						color = "color: #aaa";
					}
                    
                    return `<span title="${str}" style="${color}">${str}</span>`;
				},
                fuel_type: function(d) {
                    let str = "";
					let color = "";

					if (d) { 
                        str = d.toLowerCase();
					} else {
                        str = "Não Definido";
						color = "color: #aaa";
					}
                    
                    return `<span class="capitalized" title="${str}" style="${color}">${str}</span>`;
				},
                expanded_center: function(d) {
                    let expanded_center = "";
                    if (d != null) {
                        if (parseInt(d) == 1) expanded_center = "SIM";
                        else expanded_center = "NÃO";
                    } else expanded_center = "NÃO";
                    return "<span title='" + expanded_center + "'>" + expanded_center + "</span>";
                },

                rotation_day: function(d, item) {
                    let rotation_day = "";
                    if (item.expanded_center != null) {
                        if (parseInt(item.expanded_center) == 1) {
                            if (item.license_plate.endsWith("1") || item.license_plate.endsWith("2")) {
                                rotation_day = "SEGUNDA-FEIRA";
                            } else if (item.license_plate.endsWith("3") || item.license_plate.endsWith("4")) {
                                rotation_day = "TERÇA-FEIRA";
                            } else if (item.license_plate.endsWith("5") || item.license_plate.endsWith("6")) {
                                rotation_day = "QUARTA-FEIRA";
                            } else if (item.license_plate.endsWith("7") || item.license_plate.endsWith("8")) {
                                rotation_day = "QUINTA-FEIRA";
                            } else if (item.license_plate.endsWith("9") || item.license_plate.endsWith("0")) {
                                rotation_day = "SEXTA-FEIRA";
                            }
                        } else {
                            rotation_day = "NÃO";
                        }
                    }
                    else rotation_day = "NÃO";
                    return "<span title='" + rotation_day + "'>" + rotation_day + "</span>";
				},
			},
            
            tour_steps: [
                {
                    target: '[data-v-step-vehicle="0"]',
                    header: {
                        title: '<code>SEÇÃO VEÍCULO</code>',
                    },
                    content: '<code>Clique no menu <b>VEÍCULO</b> para ir a seção de listagem e gerenciamento dos veículos cadastrados</code>',
                    params: {
                        placement: 'right',
                        highlight: false,
                    }
                },
                {
                    target: '[data-v-step-vehicle="1"]',
                    header: {
                        title: '<code>SEÇÃO ATUAL</code>',
                    },
                    content: '<code>Identifique pelo título a seção que está atualmente</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-vehicle="2"]',
                    header: {
                        title: '<code>TOUR</code>',
                    },
                    content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-vehicle="3"]',
                    header: {
                        title: '<code>ADICIONAR VEÍCULO</code>',
                    },
                    content: '<code>Clique no botão <b>ADICIONAR</b> para abrir o formulário de cadastro manual de um novo veículo</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-vehicle="4"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campo de filtragem da lista</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-vehicle="5"]',
                    header: {
                        title: '<code>REGISTROS</code>',
                    },
                    content: '<code>Lista dos registros cadastrados</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
        }
    },

    beforeCreate: function() {
		if (!this.$api.user.is_admin) {
			let permissions = this.$api.user.permissions.split(",");
			if (!permissions.includes("Vehicle")) {
				this.$router.push({ name: 'Home' });
			}
		}
	},
    
    mounted: function() {
        this.$refs.tour.setTour();
        this.load();
        this.load_drivers();
    },
    
    activated: function() {
        this.load();
    },
    
    methods: {
        // Requisita a lista
		load: async function(is_search) {
            // Inicia o objeto das informações
            let form = {};
            
            // Verifica se houve uma busca
            if (this.search) form.search = this.search;
			if (is_search) this.page = 0;            
            form.page = this.page;
            form.per_page = this.per_page;
            
            // Verifica a ordenação
            if (this.order) form.order = this.order;
            
            // Reinicia as informações gerais
			this.list = [];
			this.total = 0;
            let result = null;

            // Requisita as informações
            this.loading = true;
            try {
                result = await Api.post("vehicle/list", form);
            } catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível excluir este veículo.");
                return;
            }
            this.loading = false;
            
            if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.list = result.data;
					this.total = result.total;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},
        
        // Requisita lista de motoristas vinculados
        load_drivers: async function() {
			let result = null;
			try {
                result = await Api.post("driver/list-my-drivers");
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações.");
                return;
            }
			
            if (result) {
                if (result.error) {
                    if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
                        this.$notification.error(result.data);
                        return;
                    }
                } else {
                    this.my_drivers = result.data;
                    return;
                }
            } else {
                this.$notification.error("Não foi possível obter a lista de motoristas.");
				return;
            }
		},

        // Adiciona nova origem
        create: function() {
            this.current = "new";
        },
        
        // Editar origem
        edit: function(item) {
            this.current = item;
        },
        
        // Remove
        remove: async function(id) {
            // Apresenta a confirmação
            let confirm = await this.$alert.confirm("Deseja mesmo remover o veículo?", "REMOVER");

            // Verifica se para remover
            if(!confirm) return;
            
            // Iniciaas variáveis necessárias
            let form = {};
            form.id = id;
            let result = null;
            
            // Requisita a remoção
            this.loading = true;
            try {
                result = await Api.post("vehicle/remove", form);
            } catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível remover o veículo.");
                return;
            }
            this.loading = false;
            
            if(result) {
				// Verifica se houve erro
				if(result.error) {
                    if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
                        this.$notification.error(result.data);
                        return;
                    }
				} else {
					this.$notification.success("Veículo removido com sucesso.");

					// Recarrega a lista
					this.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível fazer a remoção.");
				return;
			}
        },
    }
}
</script>

<style scoped>
.add_new_origin {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.search {
	background: #fff;
	padding: 15px;
	border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
}

.search > label {
	font-weight: bold;
	font-size: 12px;
}

.search > input {
	width: 140px;
	margin-left: 15px;
}
</style>